import { Box, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { getDefaultValues } from "./form-config.jsx";
import { WarningValidationForm } from "../../../components/Notifications/index.jsx";
import { getMaskPhone } from "../../../../helpers/helper.js";
import { ConfirmPhoneNumber } from "../ConfirmPhoneNumber/index.jsx";
import DefaultAvatarIcon from "../../../components/icons/DefaultAvatarIcon.jsx";
import { useTranslation } from "react-i18next";
import "./../styles/styles.css";

const ProfileMainDataForm = ({ profileData, isReadOnly, isEmpoyee = false }) => {
  const { t } = useTranslation();
  const {
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: getDefaultValues(profileData),
  });

  const isWarningValidation = !!Object.keys(errors).length;

  return (
    <>
      <div className="profile" style={isReadOnly ? { width: "100%" } : {}}>
        <div className="user-profile" style={isReadOnly && { padding: "0px" }}>
          <div className="user-profile__img">
            {profileData.avatarLink ? (
              <img src={profileData.avatarLink} alt="Аватар пользователя" />
            ) : (
              <DefaultAvatarIcon />
            )}
          </div>
          <div className="user-profile__info">
            <p className="user-profile__name">
              {profileData.lastName} {profileData.firstName} {profileData.surname}
            </p>

            <div className="user-profile__roles">
              <div>
                {t("label:role")}: {profileData.role}
              </div>
            </div>

            {profileData.subdivisionName && <div>{profileData.subdivisionName}</div>}

            <div className="user-profile__number">
              <p>{profileData.phone ? getMaskPhone(profileData.phone) : t("label:doesntHavePhone")}</p>
              {!isReadOnly && <ConfirmPhoneNumber isConfirmed={profileData.phoneVerified} />}
            </div>

            <p className="user-profile__email">{profileData.login}</p>
            {profileData.userEmployers[0] && <p className="user-profile__job-name">{profileData.userEmployers[0]}</p>}

            {profileData.facilities?.length > 0 && (
              <Box>
                <Typography sx={{ fontSize: "20px" }}>Объекты</Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    width: "100%",
                    gap: "10px",
                    overflowY: "auto",
                    maxHeight: "92px",
                  }}
                >
                  {profileData.facilities &&
                    profileData.facilities.map((item) => <Typography className="bad">{item.facilityName},</Typography>)}
                </Box>
              </Box>
            )}
          </div>
        </div>
      </div>

      {isWarningValidation && <WarningValidationForm isWarning={isWarningValidation} />}
    </>
  );
};

export default ProfileMainDataForm;
